import styles from '../IssueViewer.module.css'
import {TEST_IDS} from '../../constants/test-ids'

export type CrawlerPaginationProps = {
  nextPage: number
  canonicalUrl: string
}

export const CrawlerPagination = ({nextPage, canonicalUrl}: CrawlerPaginationProps) => {
  return (
    <div className={styles.crawlerPagination} data-testid={TEST_IDS.crawlerPagination} aria-hidden>
      <a rel={'next noreferrer'} href={`${canonicalUrl}?timeline_page=${nextPage}`} target={'_blank'}>
        Next
      </a>
    </div>
  )
}

try{ CrawlerPagination.displayName ||= 'CrawlerPagination' } catch {}